import type { RedeemResult } from '@/entities/wallet/types';
import { clientEnv } from '@/shared/config/env';
import { requestJson } from '@/shared/request/http-client';

export interface RedeemPayload {
  code: string;
}

export const redeemCode = (authToken: string, payload: RedeemPayload) =>
  requestJson<RedeemResult, { code: string; siteId: string }>('/v1/app/promo/redeem', {
    authToken,
    body: { code: payload.code, siteId: clientEnv.siteId },
    method: 'POST',
  });
